import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { useStoreBaseFunctions } from "@/composables/store/store-base-functions"
import { RentalDispenseItem } from "@/models/rental-dispense-item.model"
import { RentalDispenseItemRepository } from "@/repositories/rental-dispense-item-repository"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export const useRentalDispenseItemStore = defineStore("rentalDispenseItemStore", () => {
  const rentalDispenseItems: Ref<RentalDispenseItem[]> = ref([])

  useSocketSynchronizationHandlers(RentalDispenseItem, rentalDispenseItems)

  const { fetchModels: fetchRentalDispenseItems, saveModel: saveRentalDispenseItem } =
    useStoreBaseFunctions(RentalDispenseItem, RentalDispenseItemRepository, rentalDispenseItems)

  return {
    rentalDispenseItems,
    fetchRentalDispenseItems,
    saveRentalDispenseItem
  }
})
